import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { borderRadius, colors, spacing, typographyFlat } from '../../styles/tokens';

interface SectionNavItem {
  label: string;
  path: string;
  match: (pathname: string) => boolean;
}

const ITEMS: SectionNavItem[] = [
  {
    label: 'Combined',
    path: '/channels/combined',
    match: (pathname: string) => pathname === '/channels/combined' || pathname === '/channels',
  },
  {
    label: 'Manapool',
    path: '/channels/manapool',
    match: (pathname: string) => pathname === '/channels/manapool',
  },
  {
    label: 'Shopify',
    path: '/channels/shopify',
    match: (pathname: string) => pathname === '/channels/shopify',
  },
  {
    label: 'TCGPlayer',
    path: '/channels/tcgplayer',
    match: (pathname: string) => pathname === '/channels/tcgplayer',
  },
];

export const ChannelsSectionNav: React.FC = () => {
  const location = useLocation();

  return (
    <nav style={styles.nav} aria-label="Channels sections">
      {ITEMS.map((item) => {
        const active = item.match(location.pathname);
        return (
          <Link
            key={item.path}
            to={item.path}
            style={{
              ...styles.link,
              ...(active ? styles.linkActive : {}),
            }}
            aria-current={active ? 'page' : undefined}
          >
            {item.label}
          </Link>
        );
      })}
    </nav>
  );
};

const styles = {
  nav: {
    display: 'inline-flex',
    flexWrap: 'wrap' as const,
    gap: spacing.xs,
    borderRadius: borderRadius.full,
    backgroundColor: colors.gray100,
    padding: spacing.xs,
    marginTop: spacing.md,
  },
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    padding: `${spacing.xs} ${spacing.md}`,
    borderRadius: borderRadius.full,
    color: colors.textSecondary,
    backgroundColor: 'transparent',
    fontSize: typographyFlat.fontSize.sm,
    fontWeight: typographyFlat.fontWeight.semibold,
    lineHeight: '1.2',
    transition: 'all 0.2s ease',
  },
  linkActive: {
    color: colors.primaryDark,
    backgroundColor: colors.white,
  },
};
